<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Asignar pedido N° {{ pedido.numeroVenta }}</p>
    </header>
    <div class="modal-card-body">
      <div class="columns">
        <div
          v-for="columna in columnas"
          :key="`columna-${columna}`"
          class="column"
        >
          <div
            v-for="(usuario, index) in usuariosPorColumna(columna)"
            :key="`usuario-${columna}-${index}`"
            class="card"
            @click="asignarPedido(pedido.id, usuario)"
          >
            <div class="card-content">
              <p class="title is-4">
                {{ usuario.nombre }}
              </p>
              <p v-if="usuario.esVendedor" class="subtitle is-6">Vendedor</p>
              <p v-else class="subtitle is-6">
                {{ usuario.id }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="cerrarAsignacionHandle">
        Cerrar
      </button>
    </footer>
    <b-loading
      :is-full-page="false"
      :can-cancel="false"
      :active.sync="estaCargando"
    />
  </div>
</template>

<script>
import { pedidoService, bodegaService } from '@/services'

export default {
  name: 'SeleccionAsignacion',
  props: {
    bodega: {
      type: Object,
      required: true
    },
    pedido: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      estaCargando: true,
      bodegueros: [],
      columnas: 2
    }
  },
  computed: {
    usuarios() {
      return [
        {
          id: this.pedido.vendedor.id,
          nombre: this.pedido.vendedor.nombre,
          esVendedor: true
        },
        ...this.bodegueros
      ]
    }
  },
  mounted() {
    this.estaCargando = true
    bodegaService
      .getUsuariosByBodega(this.bodega.id)
      .then((response) => (this.bodegueros = response.data))
      .catch((error) => this.procesarError(error))
      .then(() => (this.estaCargando = false))
  },
  methods: {
    cerrarAsignacionHandle() {
      this.$emit('cancelar')
    },
    asignarPedidoAVendedor(id) {
      this.estaCargando = true
      pedidoService
        .asignarPedidoVendedor(id)
        .then(() => {
          this.notificarAccionCompletada(
            `Se asignó el pedido al vendedor ${this.pedido.vendedor.nombre}`
          )
          this.$emit('cancelar')
        })
        .catch((error) => this.procesarError(error))
        .then(() => (this.estaCargando = false))
    },
    asignarPedido(pedidoId, usuario) {
      if (usuario.esVendedor) {
        return this.asignarPedidoAVendedor(pedidoId)
      } else {
        this.estaCargando = true
        pedidoService
          .asignarPedido(pedidoId, usuario.id)
          .then(() => {
            this.notificarAccionCompletada(
              `Se asignó el pedido a ${usuario.nombre}`
            )
            this.$emit('cancelar')
          })
          .catch((error) => this.procesarError(error))
          .then(() => (this.estaCargando = false))
      }
    },
    usuariosPorColumna(columna) {
      const chunk = Math.ceil(this.usuarios.length / this.columnas)
      const first = columna * chunk - chunk
      const last = columna * chunk
      return this.usuarios.slice(first, last)
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 5px;
  &:hover {
    background-color: hsla(204, 86%, 53%, 0.8);
  }
  .card-content {
    padding: 0.5rem 1rem;
    .columns {
      margin-bottom: 0px;
      .column {
        padding: 0.5rem;
      }
    }
  }
}
</style>
